var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMenuinline = function SvgMenuinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 4.858c0-.594.478-1.072 1.071-1.072H20.93c.593 0 1.071.478 1.071 1.072 0 .593-.478 1.071-1.071 1.071H3.07A1.069 1.069 0 0 1 2 4.858ZM2 12c0-.593.478-1.071 1.071-1.071H20.93c.593 0 1.071.478 1.071 1.071 0 .594-.478 1.072-1.071 1.072H3.07A1.069 1.069 0 0 1 2 12Zm14 7.143c0 .594-.478 1.072-1.071 1.072H3.07A1.069 1.069 0 0 1 2 19.143c0-.594.478-1.071 1.071-1.071H14.93c.593 0 1.071.477 1.071 1.071Z",
    fill: "#000"
  })));
};
export default SvgMenuinline;